import { IllumiLogoMark } from "@src/components/illumi-logo-mark";
import { buildAuthorizationParams } from "@src/utils/auth-params";
import {
	captureReferralCode,
	getStoredReferralCode,
} from "@src/utils/referral-tracker";
import { captureUtmParams, getStoredUtmParams } from "@src/utils/utm-tracker";
import { loginInteractively } from "./desktop-browser-login";
import {
	getAuthReturnPathname,
	getAuthReturnTo,
	shouldUseSignupScreenHint,
} from "./desktop-browser-login-return";

/**
 * Shown when desktop browser-login mode is on and the user is signed out.
 * Login opens the system browser only after an explicit click.
 *
 * Uses native buttons (not Mantine) because this screen renders outside
 * AuthenticatedLayout’s MantineProvider.
 */
export function DesktopSignedOutScreen() {
	const handleSignIn = () => {
		const pathname = getAuthReturnPathname();
		const utmParams = captureUtmParams() ?? getStoredUtmParams();
		const referralCode = captureReferralCode() ?? getStoredReferralCode();
		const authorizationParams: Record<string, string> = {
			...buildAuthorizationParams(utmParams, referralCode),
			...(shouldUseSignupScreenHint(pathname, referralCode)
				? { screen_hint: "signup" }
				: {}),
		};
		void loginInteractively({
			appState: {
				returnTo: getAuthReturnTo(),
			},
			authorizationParams,
		});
	};

	return (
		<div className="flex min-h-dvh w-full flex-col items-center justify-center bg-surface-app px-6">
			<IllumiLogoMark className="mb-8" />
			<h1 className="mb-3 text-center text-2xl font-bold text-text-primary">
				Sign in to illumi
			</h1>
			<p className="mb-10 max-w-md text-center text-lg text-muted">
				Continue in your browser to sign in, then return to this window.
			</p>
			<button
				type="button"
				className="min-w-40 cursor-pointer rounded-sm bg-brand-primary px-6 py-2.5 text-lg font-medium text-text-inverse hover:bg-brand-primary-hover"
				onClick={handleSignIn}
			>
				Sign in
			</button>
		</div>
	);
}
